import { defineComponent as n, openBlock as r, createBlock as t, unref as p, mergeProps as d, withCtx as m, createElementVNode as a } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconCamera",
  __name: "IconCamera",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const l = o;
    return (u, e) => (r(), t(p(i), d(l, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M12 10.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5M9.75 14a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M8.178 4.197A1.25 1.25 0 0 1 9.39 3.25h5.22a1.25 1.25 0 0 1 1.212.947l.764 3.053H19.5a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 7.25h2.914l.764-3.053m6.236.553.626 2.5H8.96l.626-2.5h4.829m-9.914 4A.75.75 0 0 0 3.75 9.5v9a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.75-.75h-15",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
